import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=4a25f5ea&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=4a25f5ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a25f5ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a25f5ea')) {
      api.createRecord('4a25f5ea', component.options)
    } else {
      api.reload('4a25f5ea', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=4a25f5ea&scoped=true&", function () {
      api.rerender('4a25f5ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2u77omFMFc92s/JS/comp/SearchFilterTokens.vue"
export default component.exports